var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 0C17.0399 0 21.5999 3.7871 21.5999 9.64418C21.5999 13.5489 18.3959 18.171 11.9999 23.5224C5.6039 18.171 2.3999 13.5489 2.3999 9.64418C2.3999 3.7871 6.9599 0 11.9999 0ZM19.1999 9.64418C19.1999 5.37487 16.0199 2.35224 11.9999 2.35224C7.9799 2.35224 4.7999 5.37487 4.7999 9.64418C4.7999 12.3963 7.1399 16.0423 11.9999 20.3939C16.8599 16.0423 19.1999 12.3963 19.1999 9.64418ZM11.9999 11.7612C10.6799 11.7612 9.5999 10.7027 9.5999 9.40896C9.5999 8.11522 10.6799 7.05672 11.9999 7.05672C13.3199 7.05672 14.3999 8.11522 14.3999 9.40896C14.3999 10.7027 13.3199 11.7612 11.9999 11.7612Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIconRed);
export default __webpack_public_path__ + "static/media/addressIconRed.ea8bf588aeb6d29ef94cc609ec870045.svg";
export { ForwardRef as ReactComponent };